import type { FirearmBuild } from '../models/build'

/** Canonical in-app path for a build (pretty slug URL when available). */
export function buildPath (build: Pick<FirearmBuild, 'id' | 'slug' | 'ownerUsername'>): string {
  if (build.slug && build.ownerUsername) {
    return `/builds/${build.ownerUsername}/${build.slug}`
  }
  return `/builds/${build.id}`
}
